import React from 'react';
import { Link } from 'react-router-dom';
import { QrCode } from 'lucide-react';

type PublicRaffleLayoutProps = {
  children: React.ReactNode;
};

const PublicRaffleLayout: React.FC<PublicRaffleLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-blue-500 flex flex-col">
      {/* Minimal header with just the logo - only visible on larger screens */}
      <div className="p-4 hidden md:flex md:justify-start">
        <Link to="/" className="flex items-center">
          <QrCode className="h-6 w-6 text-white" />
          <span className="ml-2 text-lg font-bold text-white">QRaffle</span>
        </Link>
      </div>

      {/* Content area - takes full height on mobile */}
      <div className="flex-grow flex items-center justify-center px-4 py-4 md:py-8">
        <div className="w-full">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PublicRaffleLayout;
